import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the IspratnicaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ispratnica',
  templateUrl: 'ispratnica.html',
})
export class IspratnicaPage {

  test = [
    { id: 1, artikle: 'test1' },
    { id: 2, artikle: 'test2' },
    { id: 3, artikle: 'test3' },
    { id: 4, artikle: 'test4' },
    { id: 5, artikle: 'test5' },
    { id: 6, artikle: 'test6' },
  ]



  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IspratnicaPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/magacin/ispratnica/ispratnica.ts